import { DepartmentUser } from "src/models/DepartmentUser";
import { createEntityModel } from "src/store/models/entity/_shared";

export const DepartmentUserEntityModel = createEntityModel<DepartmentUser>();
